import {Component, OnDestroy, OnInit} from '@angular/core';
import {PropertyService} from '../../services/property.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AssistanceProvided, AssistanceProvidedType, ContactTypes, ExtensionActivity, ExtensionEvent, Hort360GrowerProperty, Hort360PropertySummary, Meeting, PracticeChange} from '../../../../functions/src/types';
import {DataService} from '../../services/data.service';
import {AngularFirestore, AngularFirestoreCollection} from '@angular/fire/compat/firestore';
import {Observable, Subscription} from 'rxjs';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {RSLoadingModalService} from '../../../libs/rsloading/rsloading.service';
import {AddContactComponent} from '../add-contact/add-contact.component';
import {UserService} from '../../services/user.service';
import * as moment from 'moment';
import {PracticeChangeService} from '../../services/practice-change.service';
import {map} from 'rxjs/operators';
import firebase from 'firebase/compat/app';
import Style = RSDialog.Style;
import InputType = RSDialog.InputType;
import {AddAssistanceComponent} from "../add-assistance/add-assistance.component";
import {AddPracticeChangeComponent} from "../add-practice-change/add-practice-change.component";

@Component({
  selector: 'app-grower',
  templateUrl: './grower.component.html',
  styleUrls: ['./grower.component.scss']
})
export class GrowerComponent implements OnInit, OnDestroy {
  public propertySummary: Hort360PropertySummary = null;
  public growerPropertyInfo: Hort360GrowerProperty = null;
  public userId: number;

  private growerEventsSub: Subscription;
  public growerEventIds: string[] = [];
  public selectEvent: string;

  private growerMeetingsSub: Subscription;
  public growerMeetingIds: string[] = [];
  public selectMeeting: string;

  private growerAssistanceSub: Subscription;
  public growerAssistance: ExtensionAssistanceDisplay[] = [];
  public selectAssistance: string;

  private growerPracticeChangesSub: Subscription;
  public growerPracticeChanges: PracticeChangeDisplay[] = [];
  public selectPracticeChange: string;


  private growerContactSub: Subscription;
  public growerContacts: ExtensionActivityDisplay[] = [];

  public contactTypes = Object.values(ContactTypes);
  public contactTypesObjects = ContactTypes;
  public selectContact = ContactTypes.PHONE;

  public growerReefCertifiedRef: AngularFirestoreCollection<any>;
  public growerReefCertifiedItems: Observable<any>;
  public growerReefCertifiedDate: Date = new Date();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private propertyService: PropertyService,
    private rsDialogService: RSDialogService,
    private rsLoadingModalService: RSLoadingModalService,
    private fbDb: AngularFirestore,
    public dataService: DataService,
    public userService: UserService,
    public practiceChangeService: PracticeChangeService,
  ) {

  }

  async removeContact(contact: ExtensionActivity) {
    const bDelete = await this.rsDialogService.showConfirmDialog('Are you sure you want to delete this contact?', false, 'Delete Contact', RSDialog.Style.WARN);
    if (!bDelete) {
      return;
    }
    this.rsLoadingModalService.show();
    try {
      await this.dataService.deleteContact(contact.id);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
    }
    this.rsLoadingModalService.hide();
  }

  addContact(contactType: ContactTypes) {
    console.log('addContact::: contactType:: ', contactType);

    const contact = {
      id: null,
      property: this.userId + '',
      user: this.userService.activeUserId + '',
      type: contactType || ContactTypes.PHONE,
      date: +moment().format('X'),
      activities: {},
    } as ExtensionActivity;
    this.openContact(contact);
  }

  editContact(contact: ExtensionActivity) {
    console.log('editContact::: contactId:: ', contact.id);
    this.openContact(contact);
  }

  openContact(contact: ExtensionActivity) {
    console.log('openContact::: contactId:: ', contact.id);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Extension Contact';
    dialogOptions.cancelable = false;
    dialogOptions.closeButton = false;
    dialogOptions.size = RSDialog.Size.LARGE;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add our custom component;
    dialogOptions.component = AddContactComponent;

    // Use an old fashioned object to assign variable values to;
    const oValues: {contact: ExtensionActivity} = {contact};

    console.log('openContact::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(async (result) => {
      if (result) {
        this.rsLoadingModalService.show();
        try {
          // Save the contact;
          console.log('openContact::: Save:: ', oValues.contact);
          await this.dataService.addUpdateContact(oValues.contact);
        } catch (e) {
          this.rsDialogService.showErrorDialog('Something went wrong .' + e.message);
        }
        this.rsLoadingModalService.hide();
      }
    }, (e) => console.error(e));
  }

  ngOnDestroy() {
    if (this.growerEventsSub) {
      this.growerEventsSub.unsubscribe();
    }
    if (this.growerContactSub) {
      this.growerContactSub.unsubscribe();
    }
    if (this.growerMeetingsSub) {
      this.growerMeetingsSub.unsubscribe();
    }
    if (this.growerAssistanceSub) {
      this.growerAssistanceSub.unsubscribe();
    }
    if (this.growerPracticeChangesSub) {
      this.growerPracticeChangesSub.unsubscribe();
    }
  }

  ngOnInit(): void {
    if (this.dataService.initialLoad) {
      this.dataService.initialLoad.then(() => this.initView(), () => this.initView());
    } else {
      this.initView();
    }
  }

  initView() {
    this.userId = this.route.snapshot.params?.id;
    if (!this.userId) {
      this.router.navigate(['']);
      return;
    }

    console.log('Property Id', this.userId);
    const [summary, promise] = this.propertyService.getProperty(this.userId);
    console.log('Property summary', summary);
    if (!summary) {
      this.router.navigate(['']);
      return;
    }

    this.propertySummary = summary;
    promise.then(propertyInfo => {
      console.log('Property info', propertyInfo);
      this.growerPropertyInfo = propertyInfo;
      this.propertyService.addRecent(propertyInfo.propertyId);

      this.growerEventsSub = this.fbDb.collectionGroup('attendees', query => query.where('id', '==', propertyInfo.propertyId + ''))
        .stateChanges().subscribe(v => {
          console.log(v);
          v.forEach(value => {
            const eventId = value.payload.doc.ref.parent.parent.id; // user > attendees > event
            const index = this.growerEventIds.indexOf(eventId);
            if (index === -1 && value.type === 'added') {
              this.growerEventIds.push(eventId);
            } else if (index !== -1 && value.type === 'removed') {
              this.growerEventIds.splice(index, 1);
            }
          });
        });

      // Meetings
      this.growerMeetingsSub = this.fbDb.collectionGroup('attendees', query => query.where('id', '==', propertyInfo.propertyId + ''))
        .stateChanges().subscribe(v => {
          console.log(v);
          v.forEach(value => {
            const meetingId = value.payload.doc.ref.parent.parent.id; // user > attendees > event
            const index = this.growerMeetingIds.indexOf(meetingId);
            if (index === -1 && value.type === 'added') {
              this.growerMeetingIds.push(meetingId);
            } else if (index !== -1 && value.type === 'removed') {
              this.growerMeetingIds.splice(index, 1);
            }
          });
        });

      //Assistance
      this.growerAssistanceSub = this.fbDb.collection(this.dataService.assistanceRef.ref, ref => ref.where('property', '==', propertyInfo.propertyId + '').orderBy('date', 'desc'))
        .valueChanges().subscribe(v => {
          const activityTypes = this.dataService.activityTypes.getValue();
          this.growerAssistance = v.map(assistance => {

            const displayAssistance = assistance as ExtensionAssistanceDisplay;
            displayAssistance.categories = [];

            // Build types;
            displayAssistance.categories = Object.keys(displayAssistance.activities)
              .filter(k => displayAssistance.activities[k])
              .map(k => activityTypes.find(at => at.id === k))
              .filter(at => !!at)
              .map(at => at.category)
              .filter((category, index, self) => self.indexOf(category) === index);

            // Build unique categories;
            return displayAssistance;
          });
        });

      //PracticeChange
      this.growerPracticeChangesSub = this.fbDb.collection(this.dataService.practiceChangesRef.ref, ref => ref.where('property', '==', propertyInfo.propertyId + '').orderBy('date', 'desc'))
        .valueChanges().subscribe(v => {
          const practiceChangeActivities = this.dataService.practiceChangeActivities.getValue();
          this.growerPracticeChanges = v.map(practiceChange => {

            const displayPracticeChange = practiceChange as PracticeChangeDisplay;
            displayPracticeChange.category = practiceChangeActivities.find(at => at.id === displayPracticeChange.activity)?.category
            // // Build types;
            // displayPracticeChange.category = practiceChangeActivities.find(at => at.id === practiceChange.activity)?.category
            // // Build unique categories;
            return displayPracticeChange;
          });
        });

      this.growerContactSub = this.fbDb.collection(this.dataService.contactsRef.ref, ref => ref.where('property', '==', propertyInfo.propertyId + '').orderBy('date', 'desc'))
        .valueChanges().subscribe(v => {
          const activityTypes = this.dataService.activityTypes.getValue();
          this.growerContacts = v.map(contact => {

            const displayContact = contact as ExtensionActivityDisplay;
            displayContact.categories = [];

            // Build types;
            const activityCategories: string[] = Object.keys(displayContact.activities)
              .filter(k => displayContact.activities[k])
              .map(k => activityTypes.find(at => at.id === k))
              .filter(at => !!at)
              .map(at => at.category);

            const practiceChangeCategories: string[] = Object.keys(this.practiceChangeService.types)
              .filter(k => {
                const field = this.practiceChangeService.types[k].fieldId;
                return !!(displayContact[field] && displayContact[field].completed);
              });
            // Build unique categories;
            displayContact.categories = activityCategories.concat(practiceChangeCategories).filter((val, i, a) => a.indexOf(val) === i);

            return displayContact;
          });
        });

      // Hook into reef cert
      this.growerReefCertifiedRef = this.propertyService.getPropertyReefCertifiedRef(propertyInfo.propertyId);
      this.growerReefCertifiedItems = this.growerReefCertifiedRef.snapshotChanges().pipe(
        map((actions) => {
          return actions.map((a) => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );

    }, (errors) => {
      console.error(errors);
      this.router.navigate(['']);
      return;
    });
  }

  async deletePropertyReefCertifiedDate(id: string) {
    const bConfirm = await this.rsDialogService.showConfirmDialog('Are you sure you want to delete this item?', false, 'Delete?', RSDialog.Style.ERROR);
    if (!bConfirm) {
      return;
    }
    try {
      await this.growerReefCertifiedRef.doc(id).delete();
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + e.message);
    }
  }

  async addPropertyReefCertifiedDate(date: Date) {
    if (!this.growerPropertyInfo.reefCertDate){
      await this.fbDb.collection('properties').doc(String(this.growerPropertyInfo.propertyId)).set({
        reefCertDate: moment(date).format('DD/MM/YYYY')
      }, { merge: true });
      this.growerPropertyInfo.reefCertDate = moment(date).format('DD/MM/YYYY');
    }else{
      await this.growerReefCertifiedRef.add({
        date: moment(date).format('DD/MM/YYYY'),
        ts: firebase.firestore.FieldValue.serverTimestamp(),
        user: this.userService.activeUserId + '',
      });
    }
  }

  async editPropertyReefCertifiedDate(id: string) {
    const bConfirm = await this.rsDialogService.showConfirmDialog(
      'Are you sure you want to make this the initial Reef Certification date?',
      false,
      'Reef Certification Date?',
      RSDialog.Style.WARN
    );
    if (!bConfirm) {
      return;
    }

    try {
      const selectedDoc = await this.growerReefCertifiedRef.doc(id).get().toPromise();
      if (!selectedDoc.exists) {
        throw new Error('Selected reef certification record was not found.');
      }

      const selectedData = selectedDoc.data() as any;
      const selectedDate = selectedData?.date || '';

      const currentPropertyDate = this.growerPropertyInfo?.reefCertDate?.trim() || '';

      // Always update the main property record with the selected date
      await this.fbDb.collection('properties')
        .doc(String(this.growerPropertyInfo.propertyId))
        .set({
          reefCertDate: selectedDate
        }, { merge: true });

      // If the property already had a reef cert date, swap it into the collection record
      // Otherwise, remove the collection record entirely
      if (currentPropertyDate) {
        await this.growerReefCertifiedRef.doc(id).set({
          ...selectedData,
          date: currentPropertyDate
        }, { merge: true });
      } else {
        await this.growerReefCertifiedRef.doc(id).delete();
      }

      this.growerPropertyInfo.reefCertDate = selectedDate;
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + e.message);
    }
  }

  launchEvent(event: ExtensionEvent) {
    this.router.navigate(['events', event.id]);
  }
  async removeFromEvent(event: ExtensionEvent) {
    const bSure = await this.rsDialogService.showConfirmDialog('Are you sure you want to remove this grower from this event?', false, 'Remove', Style.WARN);
    if (!bSure) {
      return;
    }
    this.rsLoadingModalService.show();
    try {
      await this.dataService.addRemoveEventAttendee(event.id, this.propertySummary.id, false);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + e.message);
    }
    this.rsLoadingModalService.hide();
  }
  async addPropertyToEvent(eventId: string) {
    if (!eventId) {
      this.rsDialogService.showErrorDialog('Please select an event.');
      return;
    }
    if (this.growerEventIds.indexOf(eventId) !== -1) {
      this.rsDialogService.showErrorDialog('This property is already an attendee of the event.');
      return;
    }

    let attendees = 1;
    try {
      attendees = await this.rsDialogService.showInput('How many attendees were present for this property?', attendees, InputType.NUMBER, 'Attendees', '\\d+', 'Attendees', RSDialog.Style.SUCCESS);
      attendees = isNaN(attendees) || !isFinite(attendees) ? 1 : parseInt(attendees + '', 10);
    } catch (e) {
      return;
    }

    this.rsLoadingModalService.show();
    try {
      await this.dataService.addRemoveEventAttendee(eventId, this.propertySummary.id, true, attendees);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + e.message);
    }
    this.rsLoadingModalService.hide();
  }


  // Meetings
  launchMeeting(meeting: Meeting) {
    this.router.navigate(['meetings', meeting.id]);
  }
  async removeFromMeeting(meeting: Meeting) {
    const bSure = await this.rsDialogService.showConfirmDialog('Are you sure you want to remove this grower from this meeting?', false, 'Remove', Style.WARN);
    if (!bSure) {
      return;
    }
    this.rsLoadingModalService.show();
    try {
      await this.dataService.addRemoveMeetingAttendee(meeting.id, this.propertySummary.id, false);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + e.message);
    }
    this.rsLoadingModalService.hide();
  }
  async addPropertyToMeeting(meetingId: string) {
    if (!meetingId) {
      this.rsDialogService.showErrorDialog('Please select a meeting.');
      return;
    }
    if (this.growerMeetingIds.indexOf(meetingId) !== -1) {
      this.rsDialogService.showErrorDialog('This property is already an attendee of the meeting.');
      return;
    }

    let attendees = 1;
    try {
      attendees = await this.rsDialogService.showInput('How many attendees were present for this property?', attendees, InputType.NUMBER, 'Attendees', '\\d+', 'Attendees', RSDialog.Style.SUCCESS);
      attendees = isNaN(attendees) || !isFinite(attendees) ? 1 : parseInt(attendees + '', 10);
    } catch (e) {
      return;
    }

    this.rsLoadingModalService.show();
    try {
      await this.dataService.addRemoveMeetingAttendee(meetingId, this.propertySummary.id, true, attendees);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. ' + e.message);
    }
    this.rsLoadingModalService.hide();
  }

//Assistance
  async removeAssistance(assistance: AssistanceProvided) {
    const bDelete = await this.rsDialogService.showConfirmDialog('Are you sure you want to delete this entry of the assistance provided?', false, 'Delete Asstance Entry', RSDialog.Style.WARN);
    if (!bDelete) {
      return;
    }
    this.rsLoadingModalService.show();
    try {
      await this.dataService.deleteAssistance(assistance.id);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
    }
    this.rsLoadingModalService.hide();
  }

  addAssistance(assistanceType: string) {

    if (!assistanceType) {
      this.rsDialogService.showErrorDialog('Please select the type of assistance provided.');
      return;
    }
    console.log('addAssistance::: assistanceType:: ', assistanceType);

    const assistance = {
      id: null,
      property: this.userId + '',
      user: this.userService.activeUserId + '',
      type: assistanceType,
      date: +moment().format('X'),
      activities: {},
    } as AssistanceProvided;
    this.openAssistance(assistance);
  }
  //
  // editContact(contact: ExtensionActivity) {
  //   console.log('editContact::: contactId:: ', contact.id);
  //   this.openContact(contact);
  // }
  //
  openAssistance(assistance: AssistanceProvided) {

    console.log('openAssistance::: assistanceId:: ', assistance.id);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Assistance Provided';
    dialogOptions.cancelable = false;
    dialogOptions.closeButton = false;
    dialogOptions.size = RSDialog.Size.LARGE;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add our custom component;
    dialogOptions.component = AddAssistanceComponent;

    // Use an old fashioned object to assign variable values to;
    const oValues: {assistance: AssistanceProvided} = {assistance};

    console.log('openAssistance::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(async (result) => {
      if (result) {
        this.rsLoadingModalService.show();
        try {
          // Save the contact;
          console.log('openAssistance::: Save:: ', oValues.assistance);
          await this.dataService.addUpdateAssistance(oValues.assistance);
        } catch (e) {
          this.rsDialogService.showErrorDialog('Something went wrong .' + e.message);
        }
        this.rsLoadingModalService.hide();
      }
    }, (e) => console.error(e));
  }






  //Practice Change
  async removePracticeChange(practiceChange: PracticeChange) {
    const bDelete = await this.rsDialogService.showConfirmDialog('Are you sure you want to delete this entry of practice change?', false, 'Delete Practice Change Entry', RSDialog.Style.WARN);
    if (!bDelete) {
      return;
    }
    this.rsLoadingModalService.show();
    try {
      await this.dataService.deletePracticeChange(practiceChange.id);
    } catch (e) {
      this.rsDialogService.showErrorDialog('Something went wrong. Please try again. ' + e.message);
    }
    this.rsLoadingModalService.hide();
  }

  addPracticeChange() {

    const practiceChange = {
      id: null,
      property: this.userId + '',
      user: this.userService.activeUserId + '',
      date: +moment().format('X'),
      activity: '',
      notes: '',
    } as PracticeChange;
    this.openPracticeChange(practiceChange);
  }

  openPracticeChange(practiceChange: PracticeChange) {

    console.log('openPracticeChange::: PracticeChangeId:: ', practiceChange.id);

    const dialogOptions = new RSDialog.Options(RSDialog.Type.PROMPT, true);
    dialogOptions.title = 'Practice Change';
    dialogOptions.cancelable = false;
    dialogOptions.closeButton = false;
    dialogOptions.size = RSDialog.Size.LARGE;
    dialogOptions.style = RSDialog.Style.SUCCESS;

    // Add our custom component;
    dialogOptions.component = AddPracticeChangeComponent;

    // Use an old fashioned object to assign variable values to;
    const oValues: {practiceChange: PracticeChange} = {practiceChange};

    console.log('openPracticeChange::: values:: ', oValues);
    dialogOptions.values = oValues;

    this.rsDialogService.showDialog(dialogOptions).then(async (result) => {
      if (result) {
        this.rsLoadingModalService.show();
        try {
          // Save the contact;
          console.log('openPracticeChange::: Save:: ', oValues.practiceChange);
          await this.dataService.addUpdatePracticeChange(oValues.practiceChange);
        } catch (e) {
          this.rsDialogService.showErrorDialog('Something went wrong .' + e.message);
        }
        this.rsLoadingModalService.hide();
      }
    }, (e) => console.error(e));
  }


  getPropertyCropsString() {
    if(this.growerPropertyInfo){
      if(this.growerPropertyInfo.crops){
        return this.growerPropertyInfo.crops.map(c=>c.name).sort().join(', ');
      }
    }
    return "";
  }


}

interface ExtensionActivityDisplay extends ExtensionActivity {
  categories: string[];
}

interface ExtensionAssistanceDisplay extends AssistanceProvided {
  categories: string[];
}

interface PracticeChangeDisplay extends PracticeChange {
  category: string;
}
